const api = 'https://api.verymedia.top'


export default api